// extracted by mini-css-extract-plugin
export default {"grid":"global_grid__7k0WA","row":"global_row__kJGl9","rowSpaced":"global_rowSpaced__jRAyY","column":"global_column__Qmuyb","columnSpaced":"global_columnSpaced__uVf7n"};